export const CREATE_XSOLLA_TOKEN_REQUESTED = "CREATE_XSOLLA_TOKEN_REQUESTED";
export const CREATE_XSOLLA_TOKEN_FULFILLED = "CREATE_XSOLLA_TOKEN_FULFILLED";
export const CREATE_XSOLLA_TOKEN_REJECTED = "CREATE_XSOLLA_TOKEN_REJECTED";

export const RESET_XSOLLA_TOKEN = "RESET_XSOLLA_TOKEN";
